<template>
  <div class="c-search-highlights-tags">
    <h3
      class="c-search-tags__title"
      :class="[
        { 'is-loading': isLoading },
        previewClass
      ]"
    >
      {{ title }}
    </h3>

    <div
      class="c-search-tags__items"
      :class="[previewClass]"
    >
      <template v-if="cards.length">
        <button
          v-for="(card, index) in cards"
          v-show="isLoading || card.label"
          :key="`tag-${card.label}-${index}`"
          class="c-search-tags__button"
          :class="[
            { 'is-loading': isLoading },
            previewClass
          ]"
          @click.prevent="chooseSearchTag(card)"
        >
          {{ card.label }}
        </button>
      </template>

      <span v-else>
        <slot />
      </span>
    </div>
  </div>
</template>

<script>
  import { PRODUCTS_SEARCH_CONTEXT } from '@/tools/constants/contexts-for-metrics'

  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      cards: {
        type: Array,
        default: () => []
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      previewClass: {
        type: String,
        default: '',
        validator: value => ['', '-mobile-preview', '-desktop-preview'].indexOf(value) !== -1
      }
    },
    data() {
      return {
        searchBarRecentContext: PRODUCTS_SEARCH_CONTEXT.SEARCH_BAR_RECENT
      }
    },
    methods: {
      chooseSearchTag(card) {
        const suggestedTerm = { text: card.label, url: card.url }
        const context = this.searchBarRecentContext

        this.$emit('choose-term', suggestedTerm, context)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @mixin titleMobileStyles() {
    margin-bottom: 24px;
  }

  .c-search-tags__title {
    color: $color-neutral-900;
    font-size: 20px;
    font-weight: $font-weight-semi-bold;
    line-height: 28px;

    @include breakpoint($until: md) {
      margin-bottom: 16px;
    }

    &:not(.-desktop-preview) {
      @include breakpoint(lg) {
        @include titleMobileStyles;
      }
    }

    &.-mobile-preview {
      @include titleMobileStyles;
    }

    &.is-loading {
      @include content-placeholder;

      width: 140px;
      height: 20px;
    }
  }

  @mixin itemsMobileStyles() {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .c-search-tags__items {
    align-items: flex-start;
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    line-height: 20px;

    &:not(.-desktop-preview) {
      @include breakpoint($until: lg) {
        @include itemsMobileStyles;
      }
    }

    &.-mobile-preview {
      @include itemsMobileStyles;
    }
  }

  @mixin buttonMobileStyles() {
    color: $color-neutral-900;
    font-size: 14px;
    line-height: 18px;
    font-weight: $font-weight-medium;
    max-width: calc(50% - 4px);
    margin-bottom: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: $color-green-neon-100;
    padding: 7px 12px;
    border-radius: 12px;
  }

  @mixin buttonLoadingMobileStyles() {
    width: 50%;
    height: 30px;
  }

  .c-search-tags__button {
    color: $color-neutral-900;
    font-size: 14px;
    line-height: 18px;
    font-weight: $font-weight-medium;
    max-width: 100%;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: $color-green-neon-100;
    padding: 7px 12px;
    border-radius: 12px;

    &:hover {
      background-color: $color-secondary-06;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:not(.-desktop-preview) {
      @include breakpoint($until: lg) {
        @include buttonMobileStyles;
      }
    }

    &.-mobile-preview {
      @include buttonMobileStyles;
    }

    &.is-loading {
      @include content-placeholder;

      color: transparent;
      width: 78px;
      height: 16px;

      &:not(.-desktop-preview) {
        @include breakpoint($until: lg) {
          @include buttonLoadingMobileStyles()
        }
      }

      &.-mobile-preview {
        @include buttonLoadingMobileStyles()
      }
    }
  }
</style>
